export const initMore = function () {
  const moreBtn = document.querySelector('[data-more]');
  const moreList = document.querySelector('[data-more-list]');
  const linkMore = document.querySelector('[data-char="link"]');
  const linkMoreText = document.querySelector('[data-char="link"] span');

  if (moreBtn) {
    if (moreList) {
      moreList.classList.add('is-collapse-list');
    }
    moreBtn.addEventListener('click', function (evt) {
      evt.preventDefault();
      if (moreList.classList.contains('is-collapse-list')) {
        moreList.classList.remove('is-collapse-list');
        if (linkMore.classList.contains('is-active')) {
          linkMore.classList.remove('is-active');
          linkMoreText.textContent = 'Свернуть';
        }
      } else {
        moreList.classList.add('is-collapse-list');
        linkMore.classList.add('is-active');
        linkMoreText.textContent = 'Смотреть все характеристики';
      }
    })
  }
}
